import { Injectable } from '@angular/core';
import {
  EmailMailboxListResponseDTO,
  EmailMailboxMessageDetailDTO,
  EmailMailboxSearchRequestDTO,
  EmailMailboxStatusDTO,
} from '../dtos/email-mailbox/email-mailbox.model';
import { ApiBase } from './proxy.base';

@Injectable({ providedIn: 'root' })
export class EmailMailboxApi extends ApiBase {
  getStatus() {
    return this.get<EmailMailboxStatusDTO>('email-mailbox/status');
  }

  getMessages(request: EmailMailboxSearchRequestDTO) {
    return this.get<EmailMailboxListResponseDTO>('email-mailbox/messages', {
      fromUtc: request.fromUtc,
      toUtc: request.toUtc,
      searchText: request.searchText,
      limit: request.limit,
    });
  }

  getMessage(messageId: string) {
    return this.get<EmailMailboxMessageDetailDTO>(
      `email-mailbox/messages/${encodeURIComponent(messageId)}`,
    );
  }

  downloadMessage(messageId: string) {
    return this.getBlobResponse(`email-mailbox/messages/${encodeURIComponent(messageId)}/download`);
  }

  getAttachment(messageId: string, attachmentId: string) {
    return this.getBlobResponse(
      `email-mailbox/messages/${encodeURIComponent(messageId)}/attachments/${encodeURIComponent(
        attachmentId,
      )}`,
    );
  }
}
